export default "__VITE_ASSET__CLkFsupQ__"